import React from 'react'
import { Text } from 'components/base'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default function SwitchableAnalyticsTable({
  tabs = [],
  selectedTabIndex = 0,
  onTabSwitched,
}) {
  return (
    <React.Fragment>
      <section>
        <div className="flexbox">
          {tabs.map((tab, index) => {
            const { name } = tab
            return (
              <Text.Callout
                key={index}
                className={classnames(
                  'uppercase margin-bottom-medium pointer',
                  {
                    'shade-30 shade-10-on-hover': index !== selectedTabIndex,
                    'margin-left-normal': index > 0,
                  }
                )}
                onClick={() => onTabSwitched(index)}
              >
                {name}
              </Text.Callout>
            )
          })}
        </div>
        {tabs.map((tab, index) => {
          const { renderTab } = tab
          const style = index === selectedTabIndex ? {} : { display: 'none' }

          return (
            <div key={index} style={style}>
              {renderTab()}
            </div>
          )
        })}
      </section>
    </React.Fragment>
  )
}

SwitchableAnalyticsTable.propTypes = {
  onTabSwitched: PropTypes.func.isRequired,
  selectedTabIndex: PropTypes.number,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      renderTab: PropTypes.func.isRequired,
    }).isRequired
  ).isRequired,
}
